// @flow
import React from 'react';
import type { Element } from 'react';

import { withTranslation } from '@i18n';

import { HospitalMap } from '@images/svg/index';

import {
  StyledTeaserCandidates,
  StyledTeaserCandidatesMap,
  StyledTeaserCandidatesTitle,
  StyledTeaserCandidatesText,
  VerticalGrid,
  StyledCoverMaxWidthPadding,
  StyledHospitalLogo,
  StyledHospitalLogoWrapper,
  StyledHospitalLogoMainWrapper
} from './styles';

import type { Props } from './types';

const TeaserCandidates = ({
  t,
  // eslint-disable-next-line no-unused-vars
  showDialog
}: {
  t: Function,
  showDialog: () => void
}): Element<any> => (
  <StyledTeaserCandidates>
    <StyledTeaserCandidatesTitle>{t('TeaserCandidates.MapHeader')}</StyledTeaserCandidatesTitle>
    <StyledTeaserCandidatesMap size={{ mobile: 1, desktop: 6 / 12 }}>
      <HospitalMap />
    </StyledTeaserCandidatesMap>

    <VerticalGrid size={{ mobile: 1, desktop: 6 / 12 }}>
      <StyledTeaserCandidatesTitle laptop>
        {t('TeaserCandidates.MapHeader')}
      </StyledTeaserCandidatesTitle>
      <StyledTeaserCandidatesText>{t('TeaserCandidates.MapCopy')}</StyledTeaserCandidatesText>
      <StyledHospitalLogoMainWrapper>
        <StyledHospitalLogoWrapper>
          <StyledHospitalLogo>
            <img src="../../../../../../static/images/about/apollohospitals.png" alt="ApolloImg" />
          </StyledHospitalLogo>
          <StyledHospitalLogo>
            <img src="../../../../../../static/images/about/artemishospitals.png" alt="FortisImg" />
          </StyledHospitalLogo>
        </StyledHospitalLogoWrapper>
        <StyledHospitalLogoWrapper>
          <StyledHospitalLogo>
            <img
              src="../../../../../../static/images/about/fortishospitals.png"
              alt="MaxhealthcareImg"
            />
          </StyledHospitalLogo>
          <StyledHospitalLogo>
            <img src="../../../../../../static/images/about/maxhealthcare.png" alt="ArtemisImg" />
          </StyledHospitalLogo>
        </StyledHospitalLogoWrapper>
      </StyledHospitalLogoMainWrapper>
    </VerticalGrid>
  </StyledTeaserCandidates>
);

const Candidates = ({ t, showDialog }: Props): Element<any> => (
  <StyledCoverMaxWidthPadding>
    <TeaserCandidates t={t} showDialog={showDialog} />
  </StyledCoverMaxWidthPadding>
);

export default withTranslation('Hospitals')(Candidates);
